import { Language } from './types';
import mjml2html from 'mjml';
import ejs from 'ejs';
import { css } from './emotion';
import { registerComponent } from 'mjml-core';

import {
  footer,
  list,
  mailto,
  media,
  tel,
  translate,
  veeva,
} from './ejsHelpers';
import { McImage } from './mjmlComponents/mc-image';

registerComponent(McImage);

export const compileTemplate = async (
  src: string,
  language: Language,
  isForRenderedPreview: boolean,
): Promise<{
  html: string;
  errors: any[];
  ejsOutput: string;
  nonBreakingTerms: string[];
  removeVMLTags: boolean;
  postProcessFunction: (html: string) => string;
}> => {
  let ejsOutput;
  let nonBreakingTerms: string[] = [];
  let removeVMLTags = false;
  let postProcessFunction = (html: string) => html;
  try {
    const enFr = translate(language);
    ejsOutput = ejs
      .render(src, {
        enFr,
        list,
        footer: footer(enFr),
        media,
        veeva,
        css,
        setNonBreaking: (terms: string[]) => nonBreakingTerms.push(...terms),
        setRemoveVMLTags: (active?: boolean) => {
          removeVMLTags = Boolean(active);
        },
        /** hide tracking pixels for preview */
        hideForPreview: (input: string) => (isForRenderedPreview ? '' : input),
        experimentalSetPostProcessFunction: (
          input: (html: string) => string,
        ) => {
          postProcessFunction = input;
        },
        mailto,
        tel,
      })
      .trim();
  } catch (e) {
    console.error('ejs template render error', e);
    throw e;
  }

  if (!ejsOutput.includes('<mjml')) {
    // not mjml, assuming it's html
    return {
      html: ejsOutput,
      ejsOutput,
      errors: [],
      nonBreakingTerms,
      removeVMLTags,
      postProcessFunction,
    };
  }

  return {
    ejsOutput,
    ...(await mjml2html(ejsOutput, {
      // minify,

      // TODO: We probably want to change this to 'skip' validation, and
      // have mjml do a validation pass separately from the rendering pass
      // @ts-ignore out of date types
      level: 'soft',

      // XXX: mjml-parse-xml added a few lines so that if filePath is defined (which it is by default, with a value of ".")
      // and if it can't successfully ensure that the passed in filePath is a directory, MJMLParser will now throw.
      // We have to futher coerce the `null` to `any` because @types/mjml is wrong and doesn't allow this field to be null
      // https://github.com/mjmlio/mjml/blob/246df840f4d0fcd812e51ca55bd6bef6592cb0e6/packages/mjml-parser-xml/src/index.js#L46-L53
      // We can also solve this error by installing memfs and telling webpack to alias 'memfs': 'fs'
      // https://github.com/streamich/memfs-webpack
      filePath: null as any,
    })),
    nonBreakingTerms,
    removeVMLTags,
    postProcessFunction,
  };
};
